import { Link } from 'react-router-dom';
import { brand } from '@/config/brand';
import { adsConfig } from '@/config/ads';

export function PrivacyPage() {
  return (
    <article className="panel prose-page">
      <h1>Privacy</h1>
      <p>
        This policy describes how {brand.name} ({brand.domain}) handles
        information when you use the site. The product is designed to work
        primarily in your browser. We do not require an account to compare
        drinks.
      </p>

      <h2>Information stored on your device</h2>
      <p>
        Price overrides, sort and filter preferences, volume-unit choice, and
        baseline selection are stored in your browser’s localStorage on this
        device. They are not synced across devices and are not uploaded to a{' '}
        {brand.name} user database in the current product.
      </p>
      <p>
        Share links can include filters and drink IDs in the query string. Your
        price overrides are included only if you opt into “Include my prices,”
        encoded in the URL fragment and labeled as user-entered. Anyone you send
        that link to can see those values.
      </p>

      <h2>Feedback submissions</h2>
      <p>
        If you use the <Link to="/feedback/">feedback form</Link>, the message
        you submit (and any contact details you include) is delivered to the site
        operator so we can respond or fix data. Do not include passwords or
        unrelated personal documents.
      </p>

      <h2>Advertising and measurement</h2>
      <p>
        {adsConfig.enabled ? (
          <>
            The site may load Google AdSense’s client script (publisher ID{' '}
            {adsConfig.clientId}) so the domain can be verified and, when ad
            units are configured, display advertising on substantial pages such
            as guides. Ad unit slot IDs may be empty until units are created; in
            that case no ad creatives render even if the script is present.
          </>
        ) : (
          <>
            Display advertising is currently disabled in site configuration.
          </>
        )}{' '}
        Comparisons and rankings remain usable if ads are blocked or unavailable.
      </p>
      <p>
        Where required (including the EEA, UK, and Switzerland, and applicable US
        state privacy options), personalized ads should be gated by a
        Google-certified consent management platform (CMP). Until a CMP is fully
        configured for this property, treat advertising as limited / non-personalized
        where Google’s defaults apply, and do not assume your drink searches or
        local price overrides are used for ad targeting. We do not sell your
        localStorage price overrides as a data product.
      </p>
      <p>
        Google may process certain technical data (for example cookie or device
        identifiers associated with AdSense) under Google’s policies when ads are
        active. Review Google’s publisher and advertising documentation for
        details on their processing.
      </p>

      <h2>Analytics</h2>
      <p>
        Product analytics events in the client are designed to no-op until an
        owner configures a provider. We do not currently send free-text search
        queries or raw user price overrides to an ad-targeting pipeline by
        default.
      </p>

      <h2>Children</h2>
      <p>
        {brand.adultNotice} The site is not directed at children. Do not use it
        if you are under the legal drinking age where you live.
      </p>

      <h2>Contact</h2>
      <p>
        Privacy questions:{' '}
        {brand.contactEmail ? (
          <a href={`mailto:${brand.contactEmail}`}>{brand.contactEmail}</a>
        ) : (
          'configure owner email'
        )}{' '}
        or the <Link to="/feedback/">feedback form</Link>.
      </p>
      <p className="muted">Last updated: October 21, 2026.</p>
    </article>
  );
}
